/**
 * validate if the string contain only letters and space between them
 * @param value string
 * @returns boolean
 */
export const acceptOnlyLetters = (value: string): boolean => {
  return new RegExp(/^([a-zA-Z]+\s?)*\s*$/g).test(value);
};
